if (!customElements.get('filter-drawer')) {
    class FilterDrawer extends HTMLElement {
			constructor() {
				super();
				this.sectionId = this.dataset.sectionId;
				this.reloadElSelectors = this.dataset.reload?.split(',') ?? null;
				this.drawerOpen = false;
			}

			connectedCallback() {
				const searchParams = new URLSearchParams(window.location.search);
				if (searchParams.get('filter.v.price.gte')) {
					searchParams.delete('filter.v.price.gte');
					history.pushState({}, null, `${window.location.pathname}?${searchParams.toString()}`);
				}
				if (searchParams.get('filter.v.price.lte')) {
					searchParams.delete('filter.v.price.lte');
					history.pushState({}, null, `${window.location.pathname}?${searchParams.toString()}`);
				}

				this.addDelegatedClickListeners();
			}

      addDelegatedClickListeners() {

				window.addEventListener('change', debounce((e) => {
					const input = e.target;
					if (!input.dataset.paramName) return;

					const oldSearchParams = new URLSearchParams(window.location.search);
					const searchParams = new URLSearchParams();
					const radioOrCheckboxes = [...document.querySelectorAll('input[data-param-name][type="checkbox"], input[data-param-name][type="radio"]')].filter(({ checked }) => checked);

					if (oldSearchParams.get('q')) {
						searchParams.set('q',oldSearchParams.get('q'));
					}

					radioOrCheckboxes.forEach((input) => searchParams.append(input.dataset.paramName, input.value));

					[...document.querySelectorAll(`select[data-param-name][${ window.innerWidth > 768 ? 'data-desktop' : 'data-mobile' }], input[data-param-name]:not([type="checkbox"]):not([type="radio"])`)]
						.forEach((input) => searchParams.set(input.dataset.paramName, input.value));

					history.pushState({}, null, `${window.location.pathname}?${searchParams.toString()}`);
					this.fetchFilteredResults();

					[...document.querySelectorAll('[data-filters-count]')].forEach((x) => {
						if(radioOrCheckboxes.length > 0) {
							x.innerHTML = `(${radioOrCheckboxes.length})`;
							return;
						}
						x.innerHTML = '';
					})
				}, 100))
      }
			async fetchFilteredResults() {
				const searchParams = new URLSearchParams(window.location.search);
				searchParams.delete('page');
				searchParams.set('section_id', `${this.sectionId}`);

				await fetch(`${window.location.pathname}?${searchParams.toString()}`)
					.then((response) => response.text())
					.then((text) => {
						const productListing = document.querySelector('product-listing');
						const temp = document.createElement('div');
						temp.innerHTML = text;
						const newProductListing = temp.querySelector('product-listing');

						if (productListing && newProductListing) {
							productListing.innerHTML = newProductListing.innerHTML;
						}
					})
			}
    }

  customElements.define('filter-drawer', FilterDrawer);
}